import CheckCircle from 'atoms/CheckCircle/CheckCircle';
import CircleLogo from 'atoms/Icons/CircleLogo';
import Image from 'next/image';
import React from 'react';
import { INotification } from 'stores/networkInterfaces';
import { formatDateRelative, getDate } from 'utils/dateUtils';
import { defaultLoader } from 'utils/images';

import s from '../Notifications.module.scss';

interface INotificationList {
  items: INotification[];
  onNavigate: (notification: INotification) => void;
  onToggleUnread: (notification: INotification) => void;
}

interface INotificationGroup {
  [key: string]: INotification[];
}

const NotificationList = ({ items, onNavigate, onToggleUnread }: INotificationList) => {
  const groups = items.reduce(function (r: INotificationGroup, a) {
    const group = formatDateRelative(getDate(a.created_at));
    if (group) {
      r[group] = r[group] || [];
      r[group].push(a);
    }
    return r;
  }, Object.create(null));

  return (
    <div className={s.Notifications__mainContent}>
      {groups &&
        items.length > 0 &&
        Object.entries(groups).map(([key, items], i) => (
          <div key={`notification-group-${i}`}>
            <div className={s.Notifications__main__sub__header}>{key}</div>
            {items.map((notification, i) => {
              const thumbnailUrl =
                notification.media && notification.media.length > 0 && notification.media[0];
              return (
                <div
                  className={s.Notifications__main__section}
                  key={`notification-item-${i}`}
                  id={`${notification.id}`}
                  onClick={() => onNavigate(notification)}
                >
                  <div className={s.Notifications__section}>
                    <div className={s.Notifications__imageHolder}>
                      {thumbnailUrl ? (
                        <Image
                          width={44}
                          height={44}
                          quality={90}
                          src={thumbnailUrl}
                          style={{ objectFit: 'cover' }}
                          loader={defaultLoader}
                          alt={notification.offering_name ?? ''}
                          className={s.Notifications__image}
                        />
                      ) : (
                        <CircleLogo />
                      )}
                    </div>
                    <div className={s.Notifications__main__msg__block}>
                      <div className={s.Notifications__main__msg__header}>
                        {`${notification.offering_id} | ${notification.offering_name ?? ''}`}
                      </div>
                      <div className={s.Notifications__main__msg__text}>{notification.message}</div>
                      <div className={s.Notifications__main__msg__footer}>
                        {formatDateRelative(notification.created_at)}
                      </div>
                    </div>
                    <CheckCircle
                      value=""
                      checked={!notification.read_at}
                      onChange={() => onToggleUnread(notification)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        ))}
    </div>
  );
};

export default NotificationList;
